import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';
import App from './components/App';
import HostDetailPage from './components/pages/HostDetailPage';
import KioskPage from './components/pages/KioskPage';
import ServerPage from './components/pages/ServerPage';
import AppPage from './components/pages/AppPage';
import UserPage from './components/pages/UserPage';
import UserCreatePage from './components/pages/UserCreatePage';
import UserEditPage from './components/pages/UserEditPage';
import RoleActionCreatePage from './components/pages/SosdbRoleActionCreatePage';
import RoleActionEditPage from './components/pages/SosdbRoleActionEditPage';
import UserProfilePage from './components/pages/UserProfilePage';
import AdminPage from './components/pages/AdminPage';
import LoginPage from './components/pages/LoginPage';
import CommissionPage from './components/pages/CommissionPage';
import NotFoundPage from './components/pages/NotFoundPage';
import StatusPage from './components/pages/StatusPage';
import KioskUpdatePage from './components/pages/KioskUpdatePage';
import KioskBatchActionPage from './components/pages/KioskBatchActionPage';
import KioskDeploymentSetCreatePage from './components/pages/KioskDeploymentSetCreatePage';
import KioskDeploymentSetEditPage from './components/pages/KioskDeploymentSetEditPage';
import Storage from './Storage';
import XpressTemplateCreatePage from './components/pages/XpressTemplateCreatePage';
import XpressTemplateApplyPage from './components/pages/XpressTemplateApplyPage';

// https://github.com/ReactTraining/react-router/blob/master/docs/API.md#onenternextstate-replace-callback
function requireAuth(nextState, replace) {
  if (!Storage.hasValidToken()) {
    let redirectAfterLogin = nextState.location.pathname;
    replace(`/login?next=${redirectAfterLogin}`);
  }
}

function clearToken() {
  Storage.clearTokenAndSessionData();
}

export default (
  <Route path='/' component={App}>
    <IndexRoute component={KioskPage} onEnter={requireAuth} />
    <Route path='login' component={LoginPage} />
    <Route path='logout' component={LoginPage} onEnter={clearToken} />

    <Route path='id/:id' component={HostDetailPage} onEnter={requireAuth} />
    <Route path='id/:id/overview' component={HostDetailPage} onEnter={requireAuth} />
    <Route path='id/:id/json' component={HostDetailPage} onEnter={requireAuth} />
    <Route path='id/:id/sheldon' component={HostDetailPage} onEnter={requireAuth} />
    <Route path='id/:id/update-history' component={HostDetailPage} onEnter={requireAuth} />

    <Route path='kiosk/all' component={KioskPage} onEnter={requireAuth} />
    <Redirect from='kiosk/prod' to='/kiosk/adm' />
    <Route path='kiosk/adm' component={KioskPage} onEnter={requireAuth} />
    <Route path='kiosk/adm/in/local' component={KioskPage} onEnter={requireAuth} />
    <Route path='kiosk/adm/he/colo' component={KioskPage} onEnter={requireAuth} />
    <Route path='kiosk/version/set' component={KioskPage} onEnter={requireAuth} />
    <Route path='kiosk/deployment/set' component={KioskPage} onEnter={requireAuth} />
    <Route path='kiosk/batch/actionhistory' component={KioskPage} onEnter={requireAuth} />
    <Route path='kiosk/update' component={KioskUpdatePage} onEnter={requireAuth} />
    <Route path='kiosk/batch/action' component={KioskBatchActionPage} onEnter={requireAuth} />
    <Route path='kiosk/deployment/set/create' component={KioskDeploymentSetCreatePage} onEnter={requireAuth} />
    <Route path='kiosk/deployment/set/edit/:name' component={KioskDeploymentSetEditPage} onEnter={requireAuth} />

    <Route path='server/all' component={ServerPage} onEnter={requireAuth} />
    <Route path='server/aws' component={ServerPage} onEnter={requireAuth} />
    <Route path='server/he-colo' component={ServerPage} onEnter={requireAuth} />

    <Route path='status' component={StatusPage} onEnter={requireAuth} />
    <Route path='app/status' component={AppPage} onEnter={requireAuth} />
    <Route path='app/prod' component={AppPage} onEnter={requireAuth} />
    <Route path='app/test' component={AppPage} onEnter={requireAuth} />
    <Route path='app/info' component={AppPage} onEnter={requireAuth} />
    <Route path='app/logurl' component={AppPage} onEnter={requireAuth} />

    <Route path='user/all' component={UserPage} onEnter={requireAuth} />
    <Route path='user/failed-login-attempts' component={UserPage} onEnter={requireAuth} />
    <Route path='user/successful-login-attempts' component={UserPage} onEnter={requireAuth} />
    <Route path='user/profile' component={UserProfilePage} onEnter={requireAuth} />
    <Route path='user/create' component={UserCreatePage} onEnter={requireAuth} />
    <Route path='user/edit/:email' component={UserEditPage} onEnter={requireAuth} />

    {/*<Route path='admin/roleaction' component={AdminPage} onEnter={requireAuth}/>*/}
    {/*<Route path='roleaction/create' component={RoleActionCreatePage} onEnter={requireAuth}/>*/}
    {/*<Route path='roleaction/edit/:id' component={RoleActionEditPage} onEnter={requireAuth}/>*/}

    <Route path='admin' component={AdminPage} onEnter={requireAuth} />
    <Route path='admin/xpresstemplates' component={AdminPage} onEnter={requireAuth} />
    <Route path='admin/xpresstemplates/create' component={XpressTemplateCreatePage} onEnter={requireAuth} />
    <Route path='admin/xpresstemplates/apply/:id' component={XpressTemplateApplyPage} onEnter={requireAuth} />

    <Route path='admin/migratekiosk' component={AdminPage} onEnter={requireAuth} />
    <Route path='admin/migrationhistory' component={AdminPage} onEnter={requireAuth} />
    <Route path='admin/patch' component={AdminPage} onEnter={requireAuth} />
    <Route path='admin/g2copy' component={AdminPage} onEnter={requireAuth} />
    <Route path='admin/g2copyhistory' component={AdminPage} onEnter={requireAuth} />
    <Route path='admin/org2orgcopyhistory' component={AdminPage} onEnter={requireAuth} />
    <Route path='admin/org2orgcopy' component={AdminPage} onEnter={requireAuth} />
    <Route path='commission' component={CommissionPage} onEnter={requireAuth} />

    <Route path='*' component={NotFoundPage} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js